export default __webpack_public_path__ + "static/media/021-whatsapp.ab1d72fa.svg";